import { axios } from '@/lib/axios'
import { Team } from '../types'
import { useQuery } from '@tanstack/react-query'

export const getTeam = async (): Promise<Team> => {
  return await axios.get(`/team/getTeam`)
}
export const useTeam = () => {
  return useQuery({
    queryKey: ['team'],
    queryFn: getTeam,
  })
}
